import * as React from 'react';

interface InputProps {
  type?: string;
  autoComplete?: string;
  value?: string;
  placeholder?: string;
  readOnly?: boolean;
  change: (value: string) => void;
  className?: string;
}

export function Input(props: InputProps) {
  return (
    <input
      type={props.type ?? 'text'}
      autoComplete={props.autoComplete}
      placeholder={props.placeholder}
      disabled={props.readOnly}
      value={props.value}
      onChange={e => props.change(e.target.value)}
      className={props.className} />
  );
}

interface TextAreaProps {
  value?: string;
  placeholder?: string;
  change: (value: string) => void;
}

export function TextArea(props: TextAreaProps) {
  return (
    <textarea
      placeholder={props.placeholder}
      value={props.value}
      onChange={e => props.change(e.target.value)}>
    </textarea>
  );
}

interface CheckBoxProps {
  checked: boolean;
  title: string;
  change: (value: boolean) => void;
}

export function CheckBox(props: CheckBoxProps) {
  return (
    <div>
      <label>
        <span>
          <input
            type='checkbox'
            checked={props.checked}
            onChange={e => props.change(e.target.checked)} />
        </span>

        <span dangerouslySetInnerHTML={({ __html: props.title })}></span>
      </label>
    </div>
  );
}
